'use strict';

import {Mody} from "./mody"
import "./style.css"

function initModyOnce() {
    if (!window.modyInit) {
        window.modyInit = true;
        const m = new Mody();
        m.init();
    }
}

window.addEventListener('DOMContentLoaded', initModyOnce);

// If DOMContentLoaded already fired (e.g., script loaded late)
if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initModyOnce();
}